// extracted by mini-css-extract-plugin
module.exports = {"section":"Footer-module--section--23iAs","logo":"Footer-module--logo--1eKbS","iconGroup":"Footer-module--iconGroup--14Q-c","divider":"Footer-module--divider--1JPyL"};